import { IdModel } from './id-model'

export class IdAndNameModel extends IdModel {
  name: string
  constructor(id: number, name: string) {
    super(id)
    this.name = name
  }
}
